import { render, staticRenderFns } from "./CallBackGateway.vue?vue&type=template&id=8ce36666&scoped=true"
import script from "./CallBackGateway.vue?vue&type=script&lang=js"
export * from "./CallBackGateway.vue?vue&type=script&lang=js"
import style0 from "./CallBackGateway.vue?vue&type=style&index=0&id=8ce36666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce36666",
  null
  
)

export default component.exports